export default subscription => !!subscription && subscription.status !== 'active' && !!subscription.retention_token_code
